export const productList = [
  {
    id: 'exchange',
    titleKey: 'products.exchange',
    color: '#00c896',
    icon: 'ri-exchange-dollar-line',
    path: '/products/cex',
    image: 'http://geel.fp.08wx.cn/images/250f25b9b7cb70d1d0f8504874033360.jpg',
    features: ['高性能撮合引擎 100K TPS', 'KYC/AML 合规模块', 'PC/H5/APP 多端', '大客户定制版'],
  },
  {
    id: 'rwa',
    titleKey: 'products.rwa',
    color: '#e8a020',
    icon: 'ri-building-line',
    path: '/products/rwa',
    image: 'http://geel.fp.08wx.cn/images/1073cd16ade6174b20bb54c962638bb3.jpg',
    features: ['法律合规三层架构', '联盟链+公链混合', '智能合约分红', 'CEX 上线流通'],
  },
  {
    id: 'wallet',
    titleKey: 'products.wallet',
    color: '#00c896',
    icon: 'ri-wallet-3-line',
    path: '/products/wallet',
    image: 'http://geel.fp.08wx.cn/images/b9f21373551f841322cbbfa1978c949b.jpg',
    features: ['80+ 条公链支持', 'DApp 浏览器内置', '钱包 + IM 社交融合', '网页版全平台'],
  },
  {
    id: 'staking',
    titleKey: 'products.staking',
    color: '#e8a020',
    icon: 'ri-stack-line',
    path: '/products/staking',
    image: 'http://geel.fp.08wx.cn/images/ff4d9be8f997a4961fbac542b8357ee9.jpg',
    features: ['LP 双重收益质押', '多级联动分层架构', '多币种跨链质押池', '实时数据看板'],
  },
  {
    id: 'mining',
    titleKey: 'products.mining',
    color: '#00c896',
    icon: 'ri-cpu-line',
    path: '/products/mining',
    image: 'http://geel.fp.08wx.cn/images/57350ab62bad621e1cbf26dae79ae653.jpg',
    features: ['LP 流动性挖矿', '交易即挖矿双轨', '社交/运动行为挖矿', 'NFT 质押挖矿'],
  },
];

export const serviceList = [
  {
    id: 'cex',
    titleKey: 'services.cex.title',
    descKey: 'services.cex.desc',
    features: ['services.cex.f1', 'services.cex.f2', 'services.cex.f3'],
    color: '#00c896',
    icon: 'ri-line-chart-line',
    path: '/products/cex',
  },
  {
    id: 'wallet',
    titleKey: 'services.wallet.title',
    descKey: 'services.wallet.desc',
    features: ['services.wallet.f1', 'services.wallet.f2', 'services.wallet.f3'],
    color: '#e8a020',
    icon: 'ri-wallet-3-line',
    path: '/products/wallet',
  },
  {
    id: 'rwa',
    titleKey: 'services.rwa.title',
    descKey: 'services.rwa.desc',
    features: ['services.rwa.f1', 'services.rwa.f2', 'services.rwa.f3'],
    color: '#00c896',
    icon: 'ri-building-2-line',
    path: '/products/rwa',
  },
  {
    id: 'dapp',
    titleKey: 'services.dapp.title',
    descKey: 'services.dapp.desc',
    features: ['services.dapp.f1', 'services.dapp.f2', 'services.dapp.f3'],
    color: '#e8a020',
    icon: 'ri-apps-2-line',
    path: '/products',
  },
];